import User from "./models/User";
import Shop from "./models/Shop";
import Special from "./models/Special";
import Style from "./models/Style";
import Booth from "./models/Booth";
import {Action} from "redux-actions";
import {addDataAction, removeDataAction, updateDataAction} from "./actions";
import {Map} from "immutable";
import {userReference} from "../_helpers/utils";
import {combineReducers} from "redux";
import * as _ from "lodash";
import {addData, removeData, ResourceType, updateData} from "../_helpers/data";
import Conversation from "./models/Conversation";
import Message from "./models/Message";

// TYPES AND CONSTANTS
interface DataAction {
    resource: string;
    id?: number;
    data?: any;
}


// REDUCERS
const dataReducer = combineReducers({
    users,
    shops,
    booths,
    specials,
    styles,
    conversations,
    messages
});

export default dataReducer;

function users(state: Map<number, User> = Map<number, User>(), action: Action<DataAction>) {
    const _resource = ResourceType.user;

    if (action.payload) {
        const {resource, data, id} = action.payload;
        if (action.type == addDataAction.toString()) {
            if (resource == _resource)
                return addData(_resource, data, state);
            else {
                const userProperty = userReference(resource);
                const _data = addDataViaProperty(_resource,userProperty, data, state);

                if (resource == ResourceType.conversation)
                    return addDataViaProperty(_resource,'user2', data, _data);

                return _data;
            }
        } else if (action.type == removeDataAction.toString()) {
            if (resource == _resource)
                return removeData(id, state);
        } else if (action.type == updateDataAction.toString()) {
            if (resource == _resource)
                return updateData(id, data, state);
        }
    }

    return state;
}

function shops(state: Map<number, Shop> = Map<number, Shop>(), action: Action<DataAction>) {
    const _resource = ResourceType.shop;

    if (action.payload) {
        const {resource, data, id} = action.payload;
        if (action.type == addDataAction.toString()) {
            if (resource == _resource)
                return addData(_resource, data, state);
            else if (resource == ResourceType.booth) {
                let _data;
                if (Array.isArray(data))
                    _data = data.map(d => d.salon);
                else
                    _data = data.salon;
                return addData(_resource, _data, state);
            }
        } else if (action.type == removeDataAction.toString()) {
            if (resource == _resource)
                return removeData(id, state);
        } else if (action.type == updateDataAction.toString()) {
            if (resource == _resource)
                return updateData(id, data, state);
        }
    }

    return state;
}

function booths(state: Map<number, Booth> = Map<number, Booth>(), action: Action<DataAction>) {
    return _commonDataReducer(ResourceType.booth, state, action);
}

function specials(state: Map<number, Special> = Map<number, Special>(), action: Action<DataAction>) {
    return _commonDataReducer(ResourceType.special, state, action);
}

function styles(state: Map<number, Style> = Map<number, Style>(), action: Action<DataAction>) {
    return _commonDataReducer(ResourceType.style, state, action);
}

function conversations(state: Map<number, Conversation> = Map<number, Conversation>(), action: Action<DataAction>) {
    return _commonDataReducer(ResourceType.conversation, state, action);
}

function messages(state: Map<number, Message> = Map<number, Message>(), action: Action<DataAction>) {
    const _resource = ResourceType.message;

    if (action.payload) {
        const {resource, data, id} = action.payload;
        if (action.type == addDataAction.toString()) {
            if (resource == _resource) {
                return addData(_resource, data, state);
            } else if (resource == ResourceType.conversation) {
                return addDataViaProperty(_resource, 'last_message', data, state);
            }
        } else if (action.type == removeDataAction.toString()) {
            if (resource == _resource)
                return removeData(id, state);
        } else if (action.type == updateDataAction.toString()) {
            if (resource == _resource)
                return updateData(id, data, state);
        }
    }

    return state;
}

//HELPERS
function _commonDataReducer<T>(_resource: string, state: Map<number, T>, action: Action<DataAction>): Map<number, T> {
    if (action.payload) {
        const {resource, data, id} = action.payload;
        if (action.type == addDataAction.toString()) {
            if (resource == _resource)
                return addData(_resource, data, state);
        } else if (action.type == removeDataAction.toString()) {
            if (resource == _resource)
                return removeData(id, state);
        } else if (action.type == updateDataAction.toString()) {
            if (resource == _resource)
                return updateData(id, data, state);
        }
    }

    return state;
}

function addDataViaProperty<T>(resourceType: string, userProperty: string, data, state: Map<number, T>): Map<number, T> {
    if (userProperty) {
        let _data;
        if (Array.isArray(data))
            _data = data.map(d => _.get(d, userProperty));
        else
            _data = _.get(data, userProperty);
        return addData(resourceType, _data, state);
    }
    return state;
}


// WEBPACK FOOTER //
// ./app/client/_data/reducers.ts